import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const EntertainerIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M12.4967 10.4642C14.567 10.4642 16.2454 8.50608 16.2454 6.09073C16.2454 3.67534 14.567 1.71729 12.4967 1.71729C10.4264 1.71729 8.74805 3.67534 8.74805 6.09073C8.74805 8.50608 10.4264 10.4642 12.4967 10.4642Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4957 10.4639L11.371 11.9634C11.3014 12.0562 11.259 12.1665 11.2486 12.2821C11.2382 12.3977 11.2602 12.5139 11.312 12.6176C11.3639 12.7215 11.4437 12.8087 11.5424 12.8697C11.6411 12.9307 11.7549 12.963 11.8709 12.963H13.1204C13.2364 12.963 13.3502 12.9307 13.4489 12.8697C13.5476 12.8087 13.6274 12.7215 13.6793 12.6176C13.7311 12.5139 13.7531 12.3977 13.7427 12.2821C13.7323 12.1665 13.6899 12.0562 13.6203 11.9634L12.4957 10.4639Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6272 12.9629C12.3252 13.3866 12.1832 13.9037 12.2263 14.4222C12.2695 14.9408 12.4951 15.4272 12.863 15.7952C13.0672 15.9994 13.2292 16.2418 13.3398 16.5086C13.4503 16.7754 13.5072 17.0613 13.5072 17.3501C13.5072 17.6389 13.4503 17.9248 13.3398 18.1916C13.2292 18.4584 13.0672 18.7008 12.863 18.905"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49771 1.67785C6.94503 1.29969 6.29138 1.09652 5.62171 1.09473C3.55161 1.09473 1.87305 3.0532 1.87305 5.46818C1.87305 7.88315 3.55161 9.84166 5.62171 9.84166C6.29087 9.83983 6.94399 9.63666 7.49605 9.25849"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.6226 9.83936L6.7472 11.3388C6.81682 11.4316 6.85921 11.542 6.86964 11.6575C6.88005 11.7731 6.85809 11.8893 6.8062 11.9931C6.75431 12.0969 6.67455 12.1841 6.57585 12.2451C6.47715 12.3061 6.36341 12.3384 6.24738 12.3384H4.99783C4.8818 12.3384 4.76806 12.3061 4.66936 12.2451C4.57066 12.1841 4.49089 12.0969 4.43901 11.9931C4.38712 11.8893 4.36515 11.7731 4.37557 11.6575C4.386 11.542 4.42839 11.4316 4.498 11.3388L5.6226 9.83936Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4933 12.3384C5.79528 12.7621 5.93731 13.2791 5.89415 13.7977C5.85099 14.3162 5.62543 14.8027 5.25755 15.1707C5.0533 15.3748 4.89127 15.6172 4.78072 15.884C4.67018 16.1508 4.61328 16.4368 4.61328 16.7255C4.61328 17.0143 4.67018 17.3003 4.78072 17.567C4.89127 17.8339 5.0533 18.0763 5.25755 18.2804"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.9375 14.8379C0.764911 14.8379 0.625 14.698 0.625 14.5254C0.625 14.3528 0.764911 14.2129 0.9375 14.2129"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M0.9375 14.8379C1.11008 14.8379 1.25 14.698 1.25 14.5254C1.25 14.3528 1.11008 14.2129 0.9375 14.2129"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9.06055 18.5864C8.88796 18.5864 8.74805 18.4465 8.74805 18.2739C8.74805 18.1013 8.88796 17.9614 9.06055 17.9614"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9.05859 18.5864C9.23118 18.5864 9.37109 18.4465 9.37109 18.2739C9.37109 18.1013 9.23118 17.9614 9.05859 17.9614"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M18.4316 16.1079C18.259 16.1079 18.1191 15.968 18.1191 15.7954C18.1191 15.6227 18.259 15.4829 18.4316 15.4829"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M18.4316 16.1079C18.6043 16.1079 18.7441 15.968 18.7441 15.7954C18.7441 15.6227 18.6043 15.4829 18.4316 15.4829"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M19.0625 6.71533C18.8899 6.71533 18.75 6.57542 18.75 6.40283C18.75 6.23025 18.8899 6.09033 19.0625 6.09033"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M19.0625 6.71533C19.2351 6.71533 19.375 6.57542 19.375 6.40283C19.375 6.23025 19.2351 6.09033 19.0625 6.09033"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </SvgIcon>
  ))
);
